
























































import { TenantUserModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { districtsStore } from '@/libs/districts/+state/store';

@Component({})
export default class AccountDialog extends Page {

    dialog = false;
    valid = true;
    id: string | null = null;
    districtId: string | null = null;
    item: TenantUserModel | null = null;
    addDistrictDialog = false;
    basicRules = [
        (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
    ];

    get isNewItem() : boolean {
        return this.item?.id == Guid.EmptyGuid();
    }

    get saving(): boolean {
        return tenantUsersStore.useGetter(CrudGetter.Saving, this.id);
    }

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    @Ref() form!: any;

    open (id: string | null = null) {
        this.dialog = true;
        this.id = id;
        tenantUsersStore.dispatch(CrudAction.Get, { id: id, key: id });
        this.subscribe(tenantUsersStore, CrudReponse.Get, id).then((e: TenantUserModel) => {
            this.item = e;
        }).catch((e) => {
            this.close();
            throw e;
        })
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            tenantUsersStore.dispatch(CrudAction.Update, { item: this.item, key: this.id });
            this.subscribe(tenantUsersStore, CrudReponse.Update, this.id).then(() => {
                this.close();
                this.$emit("save");
            }); 
        }
    }

    deleteClick () {
        console.log("deleteClick")
    }

}
